import {DTCarouselNode, DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import _map from 'lodash/map';
import _omit from 'lodash/omit';
import {LandingPageSource} from 'common/src/modules/campaigns/campaigns.enums';
import {FacebookAdType} from 'common/src/modules/externalAds/externalAds.types';

export function serializeSocialCarouselNode(node: DTNode, newNode: ServerNode) {
  const carouselNode = node as DTCarouselNode;

  return {
    ...newNode,
    externalAdPrimaryText: carouselNode.externalAdPrimaryText,
    externalAdCTA: carouselNode.externalAdCTA,
    displayCarouselCardsAsVideo: carouselNode.displayCarouselCardsAsVideo,
    bestPerformingCardsFirst: carouselNode.bestPerformingCardsFirst,
    addPageProfileCard: carouselNode.addPageProfileCard,
    addMusic: carouselNode.addMusic,
    cardsInfo: _map(carouselNode.cardsInfo, (card) => _omit(card, ['creative'])),
    identity: carouselNode.identity,
    additionalIdentity: carouselNode.additionalIdentity,
    trackingPixel: carouselNode.trackingPixel,
    adNameTemplate: carouselNode.adNameTemplate || null,
    landingPageSource: carouselNode.addPageProfileCard
      ? carouselNode.landingPageSource
      : LandingPageSource.Campaign,
    landingPage: carouselNode.addPageProfileCard ? carouselNode.landingPage : '',
    displayUrl: carouselNode.addPageProfileCard ? carouselNode.displayUrl : '',
    productSelectionType: carouselNode.productSelectionType,
    adType: FacebookAdType.FacebookCarousel,
    trackingPixels: carouselNode.trackingPixels,
  };
}
